var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "explore-border" },
    [
      _c("div", { staticClass: "tips" }, [
        _vm._v(
          "Access from mainland China requires the use of a VPN. It is recommended to use Chrome or Safari version 14 or higher browsers."
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "search-box"
        },
        [
          _c(
            "div",
            { staticClass: "check-brand", on: { click: _vm.showBrand } },
            [
              _c("div", { staticClass: "check-brand-text" }, [
                _vm._v(_vm._s(_vm.checkedBrand))
              ]),
              !_vm.isShowBrand
                ? _c("i", { staticClass: "el-icon-caret-right" })
                : _vm._e(),
              _vm.isShowBrand
                ? _c("i", { staticClass: "el-icon-caret-bottom" })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "check-state", on: { click: _vm.showState } },
            [
              _c("div", { staticClass: "check-state-text" }, [
                _vm._v(_vm._s(_vm.checkedState))
              ]),
              !_vm.isShowState
                ? _c("i", { staticClass: "el-icon-caret-right" })
                : _vm._e(),
              _vm.isShowState
                ? _c("i", { staticClass: "el-icon-caret-bottom" })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "check-category", on: { click: _vm.showCategory } },
            [
              _c("div", { staticClass: "check-category-text" }, [
                _vm._v(_vm._s(_vm.checkedCategory))
              ]),
              !_vm.isShowCategory
                ? _c("i", { staticClass: "el-icon-caret-right" })
                : _vm._e(),
              _vm.isShowCategory
                ? _c("i", { staticClass: "el-icon-caret-bottom" })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "check-store", on: { click: _vm.showStore } },
            [
              _c("div", { staticClass: "check-store-text" }, [
                _vm._v(_vm._s(_vm.checkedStore))
              ]),
              !_vm.isShowStore
                ? _c("i", { staticClass: "el-icon-caret-right" })
                : _vm._e(),
              _vm.isShowStore
                ? _c("i", { staticClass: "el-icon-caret-bottom" })
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "search-result"
        },
        [
          _vm._v("\n    In the visible area, there are a total of "),
          _c("span", { staticClass: "search-result-total" }, [
            _vm._v(_vm._s(_vm.storeTotal))
          ]),
          _vm._v(" stores.\n  ")
        ]
      ),
      _vm._v(" "),
      _vm.isShowBrand
        ? _c(
            "div",
            { staticClass: "check-box" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  on: { change: _vm.changeBrand },
                  model: {
                    value: _vm.checkboxBrandValue,
                    callback: function($$v) {
                      _vm.checkboxBrandValue = $$v
                    },
                    expression: "checkboxBrandValue"
                  }
                },
                _vm._l(_vm.brandList, function(brand) {
                  return _c(
                    "el-radio",
                    {
                      key: brand.value,
                      staticStyle: {
                        display: "block",
                        padding: "10px 0px",
                        "margin-left": "5px"
                      },
                      attrs: { label: brand.value }
                    },
                    [_vm._v(_vm._s(brand.label))]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowState
        ? _c(
            "div",
            { staticClass: "check-box" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  on: { change: _vm.changeState },
                  model: {
                    value: _vm.checkboxStateValue,
                    callback: function($$v) {
                      _vm.checkboxStateValue = $$v
                    },
                    expression: "checkboxStateValue"
                  }
                },
                _vm._l(_vm.stateList, function(state) {
                  return _c(
                    "el-radio",
                    {
                      key: state.value,
                      staticStyle: {
                        display: "block",
                        padding: "10px 0px",
                        "margin-left": "5px"
                      },
                      attrs: { label: state.value }
                    },
                    [_vm._v(_vm._s(state.label))]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowCategory
        ? _c(
            "div",
            { staticClass: "check-box" },
            [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  on: { change: _vm.changeCategory },
                  model: {
                    value: _vm.checkboxCategoryValue,
                    callback: function($$v) {
                      _vm.checkboxCategoryValue = $$v
                    },
                    expression: "checkboxCategoryValue"
                  }
                },
                _vm._l(_vm.categoryList, function(category) {
                  return _c(
                    "el-radio",
                    {
                      key: category.value,
                      staticStyle: {
                        display: "block",
                        padding: "10px 0px",
                        "margin-left": "5px"
                      },
                      attrs: { label: category.value }
                    },
                    [_vm._v(_vm._s(category.label))]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowStore
        ? _c(
            "div",
            { staticClass: "check-box" },
            [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  on: { change: _vm.changeStore },
                  model: {
                    value: _vm.checkboxStoreValue,
                    callback: function($$v) {
                      _vm.checkboxStoreValue = $$v
                    },
                    expression: "checkboxStoreValue"
                  }
                },
                _vm._l(_vm.storeList, function(store) {
                  return _c(
                    "el-radio",
                    {
                      key: store.value,
                      staticStyle: {
                        display: "block",
                        padding: "10px 0px",
                        "margin-left": "5px"
                      },
                      attrs: { label: store.value }
                    },
                    [_vm._v(_vm._s(store.label))]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "GmapMap",
        {
          staticStyle: { width: "100%", height: "100%" },
          attrs: { center: _vm.center, zoom: _vm.zoom }
        },
        [
          _c(
            "GmapCluster",
            {
              attrs: {
                imagePath: _vm.imgPath,
                imageSizes: [82, 93],
                zoomOnClick: true,
                enableRetinaIcons: true
              }
            },
            _vm._l(_vm.locations, function(localtion, index) {
              return _c(
                "GmapMarker",
                {
                  key: index,
                  attrs: {
                    label: localtion.label,
                    position: localtion.position,
                    clickable: true,
                    icon: localtion.icon
                  },
                  on: {
                    click: function($event) {
                      return _vm.openInfoWindow(localtion)
                    }
                  }
                },
                [
                  localtion.show
                    ? _c(
                        "GmapInfoWindow",
                        { attrs: { position: localtion.position } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "border-radius": "10px",
                                position: "relative",
                                width: "240px",
                                height: "auto",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.gotoCustomer(localtion)
                                }
                              }
                            },
                            [
                              localtion.img
                                ? _c("img", {
                                    staticStyle: {
                                      display: "block",
                                      width: "240px",
                                      height: "95px",
                                      "object-fit": "cover"
                                    },
                                    attrs: { src: localtion.img }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "ellipsis",
                                  staticStyle: {
                                    "text-align": "left",
                                    padding: "0 10px",
                                    width: "240px",
                                    "margin-top": "5px",
                                    "font-size": "15px",
                                    "font-weight": "bold"
                                  }
                                },
                                [_vm._v(_vm._s(localtion.storeName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "ellipsis",
                                  staticStyle: {
                                    "text-align": "left",
                                    padding: "0 10px",
                                    height: "20px"
                                  }
                                },
                                [_vm._v(_vm._s(localtion.storeAddress))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "maps-btn" }, [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.zoomIn(localtion)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "el-icon-zoom-in" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.gotoReport(localtion)
                                      }
                                    }
                                  },
                                  [_vm._v("Open Report")]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "check-box-title" }, [
      _c("div", { staticClass: "check-box-content" }, [
        _vm._v("Select a Brand")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "check-box-title" }, [
      _c("div", { staticClass: "check-box-content" }, [
        _vm._v("Select a State")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "check-box-title" }, [
      _c("div", { staticClass: "check-box-content" }, [
        _vm._v("Select a Category")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "check-box-title" }, [
      _c("div", { staticClass: "check-box-content" }, [
        _vm._v("Select a Store")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ae8ecb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ae8ecb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vilocal/explore-google-maps.vue
// module id = MopJ
// module chunks = 2